import { gql, TypedDocumentNode } from "@apollo/client";
import { CRMNote } from "@/types";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";

export type NoteQueryResponse = {
  note: CRMNote;
};

export const GET_NOTE_QUERY: TypedDocumentNode<NoteQueryResponse> = gql`
  query GetNote($id: ID!) {
    note(id: $id) {
      ...CRMNoteFields
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;
